import script from "./LastCompleted.vue?vue&type=script&setup=true&lang=ts"
export * from "./LastCompleted.vue?vue&type=script&setup=true&lang=ts"

import "./LastCompleted.vue?vue&type=style&index=0&id=046f6fd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046f6fd5"]])

export default __exports__